import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { FetchMerchantReturnList } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const returnListCountSlice = createAsyncThunk('get/returnListCountSlice', FetchMerchantReturnList);

export const ReturnListSlice = createSlice({
	name: 'returnListCountSlice',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[returnListCountSlice.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[returnListCountSlice.rejected.toString()]: setAPIError,
		[returnListCountSlice.fulfilled.toString()]: (
			state: ReturnType<typeof INITIAL_STATE>,
			action: IAPI_ACTION<any>,
		) => {
			const { payload } = action;

			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = action.payload;
		},
	},
});

interface IStates {
	[ReturnListSlice.name]: ReturnType<typeof ReturnListSlice.reducer>;
}

export const returnListSelector = (state: IStates): any => {
	return state[ReturnListSlice.name] || {};
};

export const useReturnList = (): any => useSelector(returnListSelector);

export const getReturnList =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(returnListCountSlice({}));
		return;
	};

export const resetReturnList =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(ReturnListSlice.actions.RESET());
		return;
	};
